<template>
  <section :id="$options.name" class="info-dsa" v-if="details.description.trader">
    <h2 class=" info-dsa__title">Informazioni legali</h2>
    <div class="info-dsa__text">
      <template v-for="(key, index) in dsa">
        <div :key="_uid+'dsa'+index" v-if="get_info_dsa(index).visible && key" class="info-dsa__item">
          <span class="semibold">{{ get_info_dsa(index).label}}:</span>
          <vb-icon
            v-if="key === true || key === false"
            :name="key === true ? 'check_circle' : 'cross_circle'"
            :color="key === true ? sass('success') : sass('danger')"
            :size="18"
          />
          <span v-else>{{ key }}</span>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
import { get_info_dsa } from "@bookingv3/resources"

export default {
  inheritAttrs: false,
  name: 'info-dsa',

  components: {
  },

  props: {
    details: Object,
  },

  data() {
    return {
    }
  },

  computed: {
    dsa() {
      const trader = this.details.description.trader

      return Object.keys(trader).reduce((new_trader, key) => {
        const value = trader[key]
        return value && typeof value === 'object'
          ? { ...new_trader, ...value }
          : { ...new_trader, [key]: value }
      }, {})
    }
  },

  created() {
    this.get_info_dsa = get_info_dsa
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .info-dsa {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__text {
      background-color: #fafcff;
      border-radius: 10px;
      margin-bottom: 0;
      padding: 20px;

      @include media-breakpoint-up(xl){
        line-height: $font-size-base * 2;
      }
    }

    &__item {
      display: flex;
      align-items: center;

      span {
        &:first-child {
          flex-basis: 20%;
        }
        &:last-child {
         flex-basis: 80%;
        }

      }
    }
  }

</style>